export enum EvaluationRule {
	EvaluationThreshold = -1,
	ActivityRisk = 1,
	CapacityIndicatorRisk = 2,
	MarketRisk = 3,
	InspectionRisk = 4,
	AuditRisk = 5,
	DeficienciesRisk = 6,
	IncidentsRisk = 7,
}
